import React, { useState } from 'react';
import { Layout, Menu, Dropdown, Avatar, Tag, Space, Typography, Grid, Drawer, Button } from 'antd';
import { 
  UserOutlined, 
  LogoutOutlined, 
  DashboardOutlined, 
  TeamOutlined,
  SettingOutlined,
  BarChartOutlined,
  CrownOutlined,
  MenuOutlined,
  WarningOutlined
} from '@ant-design/icons';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate, Outlet, useLocation } from 'react-router-dom';

const { Header, Content } = Layout;
const { Text } = Typography;
const { useBreakpoint } = Grid;

const AdminLayout = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const screens = useBreakpoint();
  const [drawerVisible, setDrawerVisible] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/admin/login');
  };

  const menuItems = [
    {
      key: '/admin/dashboard',
      icon: <DashboardOutlined />,
      label: 'Dashboard',
      onClick: () => {
        navigate('/admin/dashboard');
        setDrawerVisible(false);
      },
    },
    {
      key: '/admin/users',
      icon: <TeamOutlined />,
      label: 'Usuarios',
      onClick: () => {
        navigate('/admin/users');
        setDrawerVisible(false);
      },
    },
    {
      key: '/admin/plans',
      icon: <SettingOutlined />,
      label: 'Planes',
      onClick: () => {
        navigate('/admin/plans');
        setDrawerVisible(false);
      },
    },
    {
      key: '/admin/stats',
      icon: <BarChartOutlined />,
      label: 'Estadísticas',
      onClick: () => {
        navigate('/admin/stats');
        setDrawerVisible(false);
      },
    },
    {
      key: '/admin/error-logs',
      icon: <WarningOutlined />,
      label: 'Logs de Errores',
      onClick: () => {
        navigate('/admin/error-logs');
        setDrawerVisible(false);
      },
    },
  ];

  const userMenuItems = [
    {
      key: 'profile',
      icon: <CrownOutlined />,
      label: user?.username,
      disabled: true,
    },
    {
      type: 'divider',
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: 'Cerrar Sesión',
      onClick: handleLogout,
    },
  ];

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Header
        style={{
          backgroundColor: '#001529',
          padding: screens.md ? '0 24px' : '0 12px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          position: 'sticky',
          top: 0,
          zIndex: 1000,
          width: '100%'
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Text
            style={{
              color: 'white',
              fontSize: screens.md ? '18px' : '16px',
              fontWeight: 'bold',
              margin: 0,
              marginRight: '24px',
              whiteSpace: 'nowrap'
            }}
          >
            {screens.md ? 'Mi Factura - Admin' : 'Admin'}
          </Text>
        </div>

        {/* Menu Desktop */}
        {screens.md ? (
          <Menu
            theme="dark"
            mode="horizontal"
            selectedKeys={[location.pathname]}
            items={menuItems}
            style={{
              backgroundColor: 'transparent',
              border: 'none',
              flex: 1,
              minWidth: 0,
              justifyContent: 'center'
            }}
          />
        ) : (
          <div style={{ flex: 1 }} />
        )}

        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          {screens.md && (
            <Space size="middle" style={{ flexShrink: 0 }}>
              <Tag
                icon={<CrownOutlined />}
                color="gold"
                style={{ fontSize: '14px', padding: '4px 12px' }}
              >
                ADMIN
              </Tag>

              <Dropdown
                menu={{ items: userMenuItems }}
                placement="bottomRight"
                trigger={['click']}
              >
                <Avatar
                  style={{
                    backgroundColor: '#f56a00',
                    cursor: 'pointer',
                  }}
                  icon={<CrownOutlined />}
                />
              </Dropdown>
            </Space>
          )}

          {/* Botón menú móvil */}
          {!screens.md && (
            <Button
              type="primary"
              ghost
              icon={<MenuOutlined />}
              onClick={() => setDrawerVisible(true)}
            />
          )}
        </div>
      </Header>

      {/* Drawer Móvil */}
      <Drawer
        title="Admin Menu"
        placement="right"
        onClose={() => setDrawerVisible(false)}
        open={drawerVisible}
        width={250}
        bodyStyle={{ padding: 0 }}
      >
        <div style={{ padding: '16px', borderBottom: '1px solid #f0f0f0', marginBottom: '8px' }}>
          <Space>
            <Avatar style={{ backgroundColor: '#f56a00' }} icon={<CrownOutlined />} />
            <Text strong>{user?.username}</Text>
          </Space>
          <div style={{ marginTop: '8px' }}>
            <Tag color="gold">ADMIN</Tag>
          </div>
        </div>
        <Menu
          mode="inline"
          selectedKeys={[location.pathname]}
          items={[
            ...menuItems,
            { type: 'divider' },
            {
              key: 'logout',
              icon: <LogoutOutlined />,
              label: 'Cerrar Sesión',
              danger: true,
              onClick: handleLogout
            }
          ]}
          style={{ border: 'none' }}
        />
      </Drawer>

      <Content
        style={{
          padding: screens.md ? '24px' : '12px',
          backgroundColor: '#f5f5f5',
          minHeight: 'calc(100vh - 64px - 120px)', // Adjusted for footer height
        }}
      >
        <div
          style={{
            maxWidth: '1400px',
            margin: '0 auto',
            backgroundColor: 'white',
            borderRadius: '8px',
            padding: screens.md ? '24px' : '12px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            overflowX: 'auto'
          }}
        >
          <Outlet />
        </div>
      </Content>
    </Layout>
  );
};

export default AdminLayout;
